import { SITE_ID } from "../assets/meta/meta";
import { REDIRECT_URI, REST_API_KEY } from "../common/social/kakao/api";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const KAKAO_ACCESS_TOKEN_KEY = "kakao_access_token";
const REMEMBERED_PHONE_KEY = "remembered_phone_num";
const TOKEN_STORAGE_MODE_KEY = "auth_token_storage_mode";
type TokenStorageMode = "local" | "session";

function getTokenStorageMode(): TokenStorageMode {
  const storedMode = window.localStorage.getItem(TOKEN_STORAGE_MODE_KEY);
  if (storedMode === "local" || storedMode === "session") return storedMode;
  if (window.sessionStorage.getItem(ACCESS_TOKEN_KEY) || window.sessionStorage.getItem(REFRESH_TOKEN_KEY)) return "session";
  return "local";
}

function getTokenStorage(): Storage {
  return getTokenStorageMode() === "session" ? window.sessionStorage : window.localStorage;
}

function getOtherTokenStorage(): Storage {
  return getTokenStorageMode() === "session" ? window.localStorage : window.sessionStorage;
}

export function setLoginPersistence(keepLogin: boolean): void {
  window.localStorage.setItem(TOKEN_STORAGE_MODE_KEY, keepLogin ? "local" : "session");
}

export function isLoginPersistenceEnabled(): boolean {
  return window.localStorage.getItem(TOKEN_STORAGE_MODE_KEY) === "local";
}

export function isUserLogin(): boolean {
  const token = getAccessToken();
  if (token) return true;
  else return false;
}

export function setAccessToken(token: string): void {
  if (token) {
    getTokenStorage().setItem(ACCESS_TOKEN_KEY, token);
    getOtherTokenStorage().removeItem(ACCESS_TOKEN_KEY);
  }
}

export function getAccessToken(): string | null {
  const token = window.sessionStorage.getItem(ACCESS_TOKEN_KEY) || window.localStorage.getItem(ACCESS_TOKEN_KEY);
  return token;
}

export function removeAccessToken(): void {
  window.localStorage.removeItem(ACCESS_TOKEN_KEY);
  window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function setRefreshToken(token: string): void {
  if (token) {
    getTokenStorage().setItem(REFRESH_TOKEN_KEY, token);
    getOtherTokenStorage().removeItem(REFRESH_TOKEN_KEY);
  }
}

export function getRefreshToken(): string | null {
  const token = window.sessionStorage.getItem(REFRESH_TOKEN_KEY) || window.localStorage.getItem(REFRESH_TOKEN_KEY);
  return token;
}

export function removeRefreshToken(): void {
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  window.sessionStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function setKakaoAccessToken(token: string): void {
  // console.log("kakao token renewed!!", token)
  if (token) window.localStorage.setItem(KAKAO_ACCESS_TOKEN_KEY, token);
}

export function getKakaoAccessToken(): string | null {
  const token = window.localStorage.getItem(KAKAO_ACCESS_TOKEN_KEY);
  return token;
}

export function removeKakaoAccessToken(): void {
  window.localStorage.removeItem(KAKAO_ACCESS_TOKEN_KEY);
}

export function setRememberedPhone(phoneNum: string): void {
  if (phoneNum) {
    window.localStorage.setItem(REMEMBERED_PHONE_KEY, phoneNum);
  }
}

export function getRememberedPhone(): string | null {
  return window.localStorage.getItem(REMEMBERED_PHONE_KEY);
}

export function removeRememberedPhone(): void {
  window.localStorage.removeItem(REMEMBERED_PHONE_KEY);
}

const DEVICE_ID_KEY = "amazing_crm_device_id";

export function getDeviceId(): string {
  const stored = window.localStorage.getItem(DEVICE_ID_KEY);
  if (stored) return stored;
  const generated =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  window.localStorage.setItem(DEVICE_ID_KEY, generated);
  return generated;
}

export function getDeviceName(): string {
  return navigator.userAgent || "CRM";
}

// 카카오톡 기본 동의항목: profile, phone_number, plusfriends
export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&state=${SITE_ID}`;


export const KAKAO_JS_KEY = "2c81c51aef9522d0b4284a16d493b628"
